import React from 'react';
// import { Link } from 'react-router-dom';

import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Z_INDEX_LAYER } from '@CommonConstants';
// import themes, { THEME_TYPES } from 'Styles/Themes';

// import Button from '@Components/Common/Button';
import ProjectEventPostButton from './ProjectEventPostButton';

const Header = ({ isNetworkConnected, projectId }) => {
  // const theme = themes[THEME_TYPES.LIGHT];

  return (
    <HeaderContainer>
      <ProjectEventPostButton isNetworkConnected={isNetworkConnected} projectId={projectId} />
    </HeaderContainer>
  );
};

Header.propTypes = {
  isNetworkConnected: PropTypes.bool.isRequired,
  projectId: PropTypes.string.isRequired,
};

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: end;
  justify-content: space-between;

  width: 100%;
  padding: 14px 12px;
  z-index: ${Z_INDEX_LAYER.LEVEL_10};
  background-color: ${({ theme }) => theme.colors.white};
`;

export default Header;
